import styles from "./styles.module.css";

const WhiteButton = ({
  textValue,
  contentIcon,
  clickFunction,
  type = "button",
  iconLeft = false,
  customStyle,
}) => {
  return (
    <>
      <button
        className={styles.logoutButton}
        onClick={clickFunction}
        type={type}
        style={customStyle}
      >
        {iconLeft && contentIcon}
        <span>{textValue}</span>
        {!iconLeft && contentIcon}
      </button>
    </>
  );
};

export default WhiteButton;
